/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'admin-dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/admin-management/admin-dashboard',
        exactMatch: true,
    },
    {
        id: 'admin-management',
        title: 'Admin Management',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'management-list',
                title: 'Management List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/admin-management/list',
                exactMatch: true,
            },
            {
                id: 'create-management',
                title: 'Create Management',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/admin-management/list/create-management',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'certificate-management',
        title: 'Certificate Management',
        type: 'collapsable',
        icon: 'heroicons_outline:check-badge',
        children: [
            {
                id: 'create-certificate',
                title: 'Create Certificate',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/certificate-management/list/create-certificate',
                exactMatch: true,
            },
            {
                id: 'certificate-list',
                title: 'Certificate List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/certificate-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'client-management',
        title: 'Client Management',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'create-client',
                title: 'Create Client',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/client-management/list/create-client',
                exactMatch: true,
            },
            {
                id: 'client-list',
                title: 'Client List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/client-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'employee-management',
        title: 'Employee Management',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            // HR Module
            {
                id: 'hr-dashboard',
                title: 'HR Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/hr-dashboard',
                exactMatch: true,
            },
            {
                id: 'hr-shift-payment-adjustment',
                title: 'HR Shift Payment Adjustment Review',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/hr-shift-payment-adjustment',
                exactMatch: true,
            },
            {
                id: 'hr-payment-report-list',
                title: 'HR Payment Report List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/hr-payment-report-list',
                exactMatch: true,
            },
            {
                id: 'expired-items-list',
                title: 'Expired Items List',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-triangle',
                link: '/employee-management/expired-items',
                exactMatch: true,
            },
            // Full-time Employee
            {
                id: 'create-employee',
                title: 'Create Employee',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/employee-management/list/create-employee',
                exactMatch: true,
            },
            {
                id: 'employee-pool',
                title: 'Employee Pool',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-pool',
                exactMatch: true,
                // badge: {
                //     title: 'New',
                //     classes: 'px-2 bg-indigo-600 text-white rounded-full',
                // },
            },
            {
                id: 'employee-list',
                title: 'Employee List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/list',
                exactMatch: true,
            },
            // Part-timer
            {
                id: 'part-timer-list',
                title: 'Part Timer List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/list',
                exactMatch: true,
            },
            // Contractor
            {
                id: 'contractor-list',
                title: 'Contractor List',
                type: 'basic',
                icon: 'heroicons_outline:briefcase',
                link: '/contractor-management/list',
                exactMatch: true,
            },
            {
                id: 'pending-part-timer-list',
                title: 'Pending Applicant List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/pending',
                exactMatch: true,
            },
            {
                id: 'rejected-part-timer-list',
                title: 'Rejected Applicant List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/rejected',
                exactMatch: true,
            },
            {
                id: 'pending-discharge-list',
                title: 'Pending Discharge / Rejoin Part-Timer',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-pending',
                exactMatch: true,
            },
            {
                id: 'current-discharge-list',
                title: 'Current Discharge Part-Timer',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-list',
                exactMatch: true,
            },
            {
                id: 'history-discharge-list',
                title: 'Discharge / Rejoin Part-Timer History',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-history',
                exactMatch: true,
            },
            {
                id: 'blacklist-list',
                title: 'Blacklisted Employee',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/blacklist',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'project-management',
        title: 'Project Management',
        type: 'collapsable',
        icon: 'heroicons_outline:briefcase',
        children: [
            {
                id: 'create-project',
                title: 'Create Project',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/project-management/list/create-project',
                exactMatch: true,
            },
            {
                id: 'project-list',
                title: 'Project List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/project-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'project-location-management',
        title: 'Project Location Management',
        type: 'collapsable',
        icon: 'heroicons_outline:map-pin',
        children: [
            {
                id: 'create-project-location',
                title: 'Create Project Location',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/project-location-management/list/create-location',
                exactMatch: true,
            },
            {
                id: 'project-location-list',
                title: 'Project Location List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/project-location-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'roster-management',
        title: 'Roster Management',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'create-roster',
                title: 'Create Roster',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/roster-management/list/create-roster',
                exactMatch: true,
            },
            {
                id: 'roster-list',
                title: 'Roster List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/roster-management/list',
                exactMatch: true,
            },
            {
                id: 'payment-holds',
                title: 'Payment Holds',
                type: 'basic',
                icon: 'heroicons_outline:pause-circle',
                link: '/roster-management/payment-holds',
                exactMatch: true,
            },
            {
                id: 'project-view',
                title: 'Project Calendar View',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/roster-management/project-view',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'finance-management',
        title: 'Finance Management',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'finance-dashboard',
                title: 'Finance Dashboard',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/finance-dashboard',
                exactMatch: true,
            },
            {
                id: 'payment-reports',
                title: 'Payment Reports',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/payment-reports',
                exactMatch: true,
            },
            {
                id: 'finance-report-list',
                title: 'Finance Report List (Original)',
                type: 'basic',
                icon: 'heroicons_outline:document-chart-bar',
                link: '/finance-management/finance-report-list',
                exactMatch: true,
            },
            {
                id: 'part-timer-list',
                title: 'Employee List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/employee-list',
                exactMatch: true,
            },
            {
                id: 'finance-shift-payment-adjustment',
                title: 'Finance Shift Payment Adjustment',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/finance-shift-payment-adjustment',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'report-management',
        title: 'Report Management',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'report-list',
                title: 'Monthly Report List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/report-management/report-list',
                exactMatch: true,
            },
            {
                id: 'weekly-report-list',
                title: 'Weekly Report List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/report-management/weekly-report-list',
                exactMatch: true,
            },
            {
                id: 'working-hours-report',
                title: 'Working Hours Report',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/report-management/working-hours-report',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'data-migration',
        title: 'Data Migration',
        type: 'collapsable',
        icon: 'heroicons_outline:arrow-path',
        children: [
            {
                id: 'roster-migration',
                title: 'Roster Migration',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path',
                link: '/data-migration/roster-migration',
            },
        ],
    },
    {
        id: 'settings',
        title: 'Settings',
        type: 'collapsable',
        icon: 'heroicons_outline:cog-6-tooth',
        children: [
            {
                id: 'claim-categories',
                title: 'Claim Categories',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/settings/claim-type-management/list',
                exactMatch: true,
            },
            {
                id: 'public-holidays',
                title: 'Public Holidays Management',
                type: 'basic',
                icon: 'heroicons_outline:calendar',
                link: '/settings/public-holidays-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'claim-management',
        title: 'Claim Management',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/claim-management',
    },
];
export const managerNavigation: FuseNavigationItem[] = [
    {
        id: 'certificate-management',
        title: 'Certificate Management',
        type: 'collapsable',
        icon: 'heroicons_outline:check-badge',
        children: [
            {
                id: 'create-certificate',
                title: 'Create Certificate',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/certificate-management/list/create-certificate',
                exactMatch: true,
            },
            {
                id: 'certificate-list',
                title: 'Certificate List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/certificate-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'client-management',
        title: 'Client Management',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'create-client',
                title: 'Create Client',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/client-management/list/create-client',
                exactMatch: true,
            },
            {
                id: 'client-list',
                title: 'Client List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/client-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'employee-management',
        title: 'Employee Management',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            // {
            //     id: 'create-employee',
            //     title: 'Create Employee',
            //     type: 'basic',
            //     icon: 'heroicons_outline:plus-circle',
            //     link: '/employee-management/list/create-employee',
            //     exactMatch: true,
            // },
            // {
            //     id: 'pending-part-timer-list',
            //     title: 'Pending Part Timer List',
            //     type: 'basic',
            //     icon: 'heroicons_outline:user-group',
            //     link: '/part-timer-management/pending',
            //     exactMatch: true,
            // },
            {
                id: 'employee-pool',
                title: 'Employee Pool',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-pool',
                exactMatch: true,
                // badge: {
                //     title: 'New',
                //     classes: 'px-2 bg-indigo-600 text-white rounded-full',
                // },
            },
            {
                id: 'employee-list',
                title: 'Employee List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/list',
                exactMatch: true,
            },
            {
                id: 'part-timer-list',
                title: 'Part Timer List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/list',
                exactMatch: true,
            },
            {
                id: 'contractor-list',
                title: 'Contractor List',
                type: 'basic',
                icon: 'heroicons_outline:briefcase',
                link: '/contractor-management/list',
                exactMatch: true,
            },
            {
                id: 'rejected-part-timer-list',
                title: 'Rejected Applicant List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/rejected',
                exactMatch: true,
            },
            {
                id: 'current-discharge-list',
                title: 'Current Discharge Part-Timer',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-list',
                exactMatch: true,
            },
            {
                id: 'history-discharge-list',
                title: 'Discharge / Rejoin Part-Timer History',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-history',
                exactMatch: true,
            },
            {
                id: 'blacklist-list',
                title: 'Blacklisted Employee',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/blacklist',
                exactMatch: true,
            },
            // {
            //     id: 'rejected-part-timer-list',
            //     title: 'Rejected Part Timer List',
            //     type: 'basic',
            //     icon: 'heroicons_outline:user-group',
            //     link: '/part-timer-management/rejected',
            //     exactMatch: true,
            // },
        ],
    },
    {
        id: 'project-management',
        title: 'Project Management',
        type: 'collapsable',
        icon: 'heroicons_outline:briefcase',
        children: [
            {
                id: 'create-project',
                title: 'Create Project',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/project-management/list/create-project',
                exactMatch: true,
            },
            {
                id: 'project-list',
                title: 'Project List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/project-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'project-location-management',
        title: 'Project Location Management',
        type: 'collapsable',
        icon: 'heroicons_outline:map-pin',
        children: [
            {
                id: 'create-project-location',
                title: 'Create Project Location',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/project-location-management/list/create-location',
                exactMatch: true,
            },
            {
                id: 'project-location-list',
                title: 'Project Location List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/project-location-management/list',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'roster-management',
        title: 'Roster Management',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'create-roster',
                title: 'Create Roster',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/roster-management/list/create-roster',
                exactMatch: true,
            },
            {
                id: 'roster-list',
                title: 'Roster List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/roster-management/list',
                exactMatch: true,
            },
            {
                id: 'payment-holds',
                title: 'Payment Holds',
                type: 'basic',
                icon: 'heroicons_outline:pause-circle',
                link: '/roster-management/payment-holds',
                exactMatch: true,
            },
            {
                id: 'project-view',
                title: 'Project Calendar View',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/roster-management/project-view',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'report-management',
        title: 'Report Management',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'report-list',
                title: 'Monthly Report List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/report-management/report-list',
                exactMatch: true,
            },
            {
                id: 'weekly-report-list',
                title: 'Weekly Report List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/report-management/weekly-report-list',
                exactMatch: true,
            },
            {
                id: 'working-hours-report',
                title: 'Working Hours Report',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/report-management/working-hours-report',
                exactMatch: true,
            },
        ],
    },
];
export const hrNavigation: FuseNavigationItem[] = [
    {
        id: 'hr-dashboard',
        title: 'HR Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/employee-management/hr-dashboard',
        exactMatch: true,
    },
    {
        id: 'employee-management',
        title: 'Employee Management',
        type: 'collapsable',
        icon: 'heroicons_outline:user-group',
        children: [
            {
                id: 'create-employee',
                title: 'Create Employee',
                type: 'basic',
                icon: 'heroicons_outline:plus-circle',
                link: '/employee-management/list/create-employee',
                exactMatch: true,
            },
            {
                id: 'hr-shift-payment-adjustment',
                title: 'HR Shift Payment Adjustment Review',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/hr-shift-payment-adjustment',
                exactMatch: true,
            },
            {
                id: 'hr-payment-report-list',
                title: 'HR Payment Report List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/hr-payment-report-list',
                exactMatch: true,
            },
            {
                id: 'expired-items-list',
                title: 'Expired Items List',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-triangle',
                link: '/employee-management/expired-items',
                exactMatch: true,
            },
            {
                id: 'employee-pool',
                title: 'Employee Pool',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-pool',
                exactMatch: true,
                // badge: {
                //     title: 'New',
                //     classes: 'px-2 bg-indigo-600 text-white rounded-full',
                // },
            },
            {
                id: 'employee-list',
                title: 'Employee List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/list',
                exactMatch: true,
            },
            {
                id: 'part-timer-list',
                title: 'Part Timer List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/list',
                exactMatch: true,
            },
            {
                id: 'contractor-list',
                title: 'Contractor List',
                type: 'basic',
                icon: 'heroicons_outline:briefcase',
                link: '/contractor-management/list',
                exactMatch: true,
            },
            {
                id: 'pending-part-timer-list',
                title: 'Pending Applicant List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/pending',
                exactMatch: true,
            },
            {
                id: 'rejected-part-timer-list',
                title: 'Rejected Applicant List',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/rejected',
                exactMatch: true,
            },
            {
                id: 'pending-discharge-list',
                title: 'Pending Discharge / Rejoin Part-Timer',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-pending',
                exactMatch: true,
            },
            {
                id: 'current-discharge-list',
                title: 'Current Discharge Part-Timer',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-list',
                exactMatch: true,
            },
            {
                id: 'history-discharge-list',
                title: 'Discharge / Rejoin Part-Timer History',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/part-timer-management/discharge-history',
                exactMatch: true,
            },
            {
                id: 'blacklist-list',
                title: 'Blacklisted Employee',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/employee-management/blacklist',
                exactMatch: true,
            },
        ],
    },
    // {
    //     id: 'claim-management',
    //     title: 'Claim Management',
    //     type: 'basic',
    //     icon: 'heroicons_outline:currency-dollar',
    //     link: '/claim-management',
    // },
];
export const financeNavigation: FuseNavigationItem[] = [
    {
        id: 'finance-dashboard',
        title: 'Finance Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/finance-management/finance-dashboard',
        exactMatch: true,
    },
    {
        id: 'finance-management',
        title: 'Finance Management',
        type: 'collapsable',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'payment-reports',
                title: 'Payment Reports',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/payment-reports',
                exactMatch: true,
            },
            {
                id: 'finance-report-list',
                title: 'Finance Report List (Original)',
                type: 'basic',
                icon: 'heroicons_outline:document-chart-bar',
                link: '/finance-management/finance-report-list',
                exactMatch: true,
            },
            {
                id: 'part-timer-list',
                title: 'Employee List',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/employee-list',
                exactMatch: true,
            },
            {
                id: 'finance-shift-payment-adjustment',
                title: 'Finance Shift Payment Adjustment',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/finance-management/finance-shift-payment-adjustment',
                exactMatch: true,
            },
        ],
    },
    {
        id: 'employee-pool',
        title: 'Employee Pool',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/employee-pool',
        exactMatch: true,
        // badge: {
        //     title: 'New',
        //     classes: 'px-2 bg-indigo-600 text-white rounded-full',
        // },
    },
    {
        id: 'claim-management',
        title: 'Claim Management',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/claim-management',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
